<template>
  <div>
    <fieldset class="pb-1 custom-fieldset">
      <v-divider />
      <v-row class="flight-divider">
        <v-col cols="4">
          <span class="white px-2">{{ contextAirlineName }}</span>
        </v-col>
        <v-spacer />
        <v-col cols="1" class="text-right">
          <span class="white px-2">{{ flightTime }}</span>
        </v-col>
      </v-row>
      <v-row style="position: relative; top: -10px" no-gutters>
        <v-col cols="2" class="px-3">
          <v-icon class="grey--text">flight_takeoff</v-icon>
          <span class="font-weight-bold">{{ route.start_time.substr(0, 5) }}</span>
        </v-col>
        <v-col cols="2">
          <span class="grey--text">
            {{ formatDateView(route.start_date) }}
          </span>
        </v-col>
        <v-col cols="6">
          <span class="font-weight-bold"> {{ route.start_place_name }}, </span>
          <span class="accent--text font-weight-bold">
            {{ route.start_airport_code }}
          </span>
          <span class="grey--text"> </span>
        </v-col>
      </v-row>

      <v-row class="my-2" no-gutters>
        <v-col cols="2" class="px-3">
          <v-icon class="grey--text">flight_land</v-icon>
          <span class="font-weight-bold">{{ route.end_time.substr(0, 5) }}</span>
        </v-col>
        <v-col cols="2">
          <span class="grey--text">
            {{ formatDateView(route.end_date) }}
          </span>
        </v-col>
        <v-col cols="6">
          <span class="font-weight-bold"> {{ route.end_place_name }}, </span>
          <span class="accent--text font-weight-bold">
            {{ route.end_airport_code }}
          </span>
          <span class="grey--text"> </span>
        </v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import dayOfWeek from "../../../repository/shortDayOfWeekFromDate";
import getTextDateDiff from "../../../repository/getTextDateDiff";
import FlightRoute from "../../../models/booking/flightRoute";
import formatDateView from "../../../repository/fotmatDateView";

export default {
  name: "BookingFlightRouteDetail",
  props: {
    route: {
      required: true,
      type: FlightRoute
    },
    airlineName: {
      required: false,
      type: String,
      default: null
    }
  },
  data: () => ({
    search: ""
  }),
  computed: {
    contextAirlineName() {
      return this.airlineName == null ? this.$t("booking.flight.noAirlineInfo") : this.airlineName;
    },
    flightTime() {
      let startDateTime = this.route.start_date + " " + this.route.start_time;
      let endDateTime = this.route.end_date + " " + this.route.end_time;
      return getTextDateDiff(startDateTime, endDateTime);
    }
  },
  methods: {
    dayOfWeek: dayOfWeek,
    getTextDateDiff: getTextDateDiff,
    formatDateView: formatDateView
  }
};
</script>

<style scoped>
.grey--text {
  color: #9e9e9e !important;
}

.flight-divider {
  font-weight: 700;
  position: relative;
  top: -11px;
}
</style>
